import React from 'react';

export default [
			{
				title: "Student",
				name: "sName",
				getTdProps: ({tbodyData})=>{
					return {
						className: "student-info",
						style: {
							width: "20%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					let maleImg = require('data/images/Male_student.png');
					let femaleImg = require('data/images/Female_student.png');

					if (!student.sName) {
						return "";
					}

					return (
						<div className="student-info-container">
							<div className="portrait" style={{
									backgroundImage: student.sGender == 0 ? `url(${maleImg})` : `url(${femaleImg})`
									}}>
							</div>
							<div className="text-container">
								<div className="name">
									{student.sName}
								</div>
								<small>
									{student.sAge} yrs old
								</small>
							</div>
						</div>
					);
				},
			},
			{
				title: "Class",
				name: "className",
				getTdProps: ({tbodyData})=>{
					return {
						className: "class-info",
						style: {
							width: "20%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					return (
						<div>
							<div className="class-info-name">
								{student.className}
							</div>
							<small>
								${student.classTotalFee}
							</small>
						</div>
					);
				},
			},
			{
				title: "Class Status",
				name: "classStatus",
			},
			{
				title: "Payment",
				name: "paidTotalFee",
			},
			{
				title: "Settings",
				name: "settings",
				getTdProps: ({tbodyData})=>{
					return {
						className: "table-controller",
						style: {
							width: "25%"
						}
					}
				},
				getTdContent: ({ trData: student })=>{
					return (
						<div>
							<Button bsStyle='link'>档案</Button>
							<Button bsStyle='link'>排班</Button>
							<Button bsStyle='link'>收费</Button>
							<Button bsStyle='link'>更多<i className="fa icon-angle-down dropdown-caret" /></Button>
						</div>
					);
				},

			},

		];



// WEBPACK FOOTER //
// ./src/containers/pages/UILibrary/example/field.js